import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { DomainDto, DomainUiLightDto, UserPermissionAssignmentDto } from '@/api';

interface DomainRoleSelectorProps {
  disabled?: boolean;
  availableDomains: DomainDto[];
  checkboxCols?: number;
  inputCols?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DomainRoleSelector',
  props: {
  disabled: { type: Boolean },
  availableDomains: null,
  checkboxCols: { default: 6 },
  inputCols: { default: 6 },
  value: null
},
  emits: ["input"],
  setup(__props) {

const props = __props;



const { value: domains } = __MACROS_useVModel(["value", undefined, "input"]);

const roles = Object.values(DomainUiLightDto.role);

const sortedDomains = _computed(() => [...props.availableDomains].sort((domain) => (domain.name === 'All' ? -1 : 1))); // avoid mutating the props availableDomains

const isSelected = (selectedDomain: DomainDto) => domains.value.some((domain) => domain.id === selectedDomain.id);

const change = (checked: boolean, domain: DomainDto) => {
  if (checked) {
    domains.value = [...domains.value, {
      id: domain.id,
      name: domain.name,
      role: DomainUiLightDto.role.VIEWER,
      isAllDomain: domain.isAllDomain,
    }];
  } else {
    domains.value = domains.value.filter((d) => d.id !== domain.id);
  }
};
const getRole = (domain: DomainDto) => {
  const d = domains.value.find((_d) => _d.id === domain.id);
  if (d) {
    return d.role;
  }
  return '';
};

const changeRole = (role: DomainUiLightDto.role, domain: DomainDto) => {
  const d = domains.value.find((_d) => _d.id === domain.id);
  if (d) {
    d.role = role;
  }
};

return { __sfc: true,props, domains, roles, sortedDomains, isSelected, change, getRole, changeRole, _computed, __MACROS_useVModel, DomainDto, DomainUiLightDto, UserPermissionAssignmentDto }
}

})